import React from "react";

const UserLogo = ({ user }) => {
  const apiUrl = process.env.REACT_APP_SHEET_URL;
  return <img src={`${apiUrl}${user.logo_url}`} />;
};

export default UserLogo;
